import { Component } from "@angular/core";

@Component({
    selector: "delete-post-action",
    template: require("./delete-post-action.component.html")
})
export class DeletePostActionComponent {

   constructor(){}

}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-form/insa-post-actions/post-action-form/delete-post-action.component.ts